// removed by extract-text-webpack-plugin
module.exports = {"currencyRoot":"CwCurrencyField-currencyRoot","currencyText":"CwCurrencyField-currencyText","currencyCode":"CwCurrencyField-currencyCode"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwcurrencyfield/CwCurrencyField.scss
// module id = 358
// module chunks = 0